import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    quote: "Advanced ADAS has become our go-to calibration partner. Their documentation is thorough and their turnaround time helps us get vehicles back to customers faster.",
    author: "John M.",
    role: "Operations Manager",
    rating: 5,
  },
  {
    quote: "The level of detail in their calibration reports gives us confidence when processing ADAS-related claims. They understand what insurers need.",
    author: "Sarah T.",
    role: "Claims Assessor",
    rating: 5,
  },
  {
    quote: "Professional service from start to finish. They explained the calibration requirements clearly and completed the work efficiently. Highly recommend.",
    author: "David L.",
    role: "Fleet Manager",
    rating: 5,
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5 },
  },
};

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-20 md:py-28 bg-slate-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="text-blue-600 text-sm font-semibold tracking-widest uppercase mb-4 block">
            Testimonials
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight mb-4">
            What Our Clients Say
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto text-base sm:text-lg">
            Trusted by repairers, insurers, and fleet operators across South Australia
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className="testimonial-card bg-white p-8 rounded-lg border border-slate-200 relative hover:shadow-lg transition-shadow"
              data-testid={`testimonial-card-${index}`}
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 text-slate-100">
                <Quote className="w-12 h-12" />
              </div>

              {/* Rating Stars */}
              <div className="flex gap-1 mb-4 relative z-10">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-slate-700 text-base leading-relaxed mb-6 relative z-10">
                "                &ldquo;{testimonial.quote}&rdquo;"
              </blockquote>

              {/* Author */}
              <div className="relative z-10">
                <p className="font-heading font-bold text-slate-900">
                  {testimonial.author}
                </p>
                <p className="text-slate-600 text-sm">
                  {testimonial.role}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
